module.exports = __webpack_public_path__ + "img/googleStore.4eff248a.png";